'use strict';

require('@babel/polyfill');

window._ = require('lodash');

window.Popper = require('popper.js').default;

window.$ = window.jQuery = require('jquery/dist/jquery.js');

window.axios = require('axios');

// Ensure plugins load via the built bundle (no external eval)
require('bootstrap');

// DataTables core and adapters
require('datatables.net');
require('datatables.net-bs4');
require('datatables.net-buttons');
require('datatables.net-buttons-bs4');
require('datatables.net-buttons/js/buttons.html5');
require('datatables.net-fixedcolumns');
require('datatables.net-fixedcolumns-bs4');
require('datatables.net-fixedheader');
require('datatables.net-fixedheader-bs4');
require('datatables.net-responsive');
require('datatables.net-responsive-bs4');


// WEBPACK FOOTER //
// ./resources/assets/js/vendor.js